import React, { useState, useEffect } from 'react';
import Ax from '../../hoc/Ax';
import DatePicker from "react-datepicker";
import moment from "moment";
import tapIcon from '../../../services/TapIcon';
import TapSelect from "../../ui/TapSelect";

const PeriodSelectionWithSeparateDates = (props) => {

    let initSelectedPeriod = props.value ? props.value : '';

    let tapSelectOptions = props.periods.map((m) => {
        return {
            value: m.key,
            label: m.display
        };
    });

    let initStartDate =
        props.value !== '' &&
        props.startDate &&
        props.startDate !== ''
            ? moment(props.startDate).toDate()
            : null;

    let initEndDate =
        props.value !== '' &&
        props.endDate &&
        props.endDate !== ''
            ? moment(props.endDate).toDate()
            : null;

    const [selectedPeriod, setSelectedPeriod] = useState(initSelectedPeriod);
    const [startDate, setStartDate] = useState(initStartDate);
    const [endDate, setEndDate] = useState(initEndDate);

    useEffect(() => {
        changePeriodHandler();
    }, [selectedPeriod, startDate, endDate])
    useEffect(() => {
    setSelectedPeriod(props.value || '');

    setStartDate(
        props.startDate
            ? moment(props.startDate).toDate()
            : null
    );

    setEndDate(
        props.endDate
            ? moment(props.endDate).toDate()
            : null
    );
}, [props.value, props.startDate, props.endDate]);;

    useEffect(() => {
        if (initSelectedPeriod) {
            const option = tapSelectOptions.find(o => o.value === initSelectedPeriod);
            if (option) {
                tapSelectChange(option);
            }
        }
    }, [initSelectedPeriod]);

    const changePeriodHandler = () => {
        props.onSelectPeriod(
            selectedPeriod,
            startDate
                ? moment(startDate).format('YYYY-MM-DD')
                : null,
            endDate
                ? moment(endDate).format('YYYY-MM-DD')
                : null
        );
    };

    const tapSelectChange = (selectedOption) => {

        if (selectedOption && selectedOption.value) {

            let sp = props.periods.find(
                (p) => p.key === selectedOption.value
            );

            if (sp && sp.key !== 'custom') {
                setStartDate(
                    sp.dateFromYmd
                        ? moment(sp.dateFromYmd).toDate()
                        : null
                );

                setEndDate(
                    sp.dateToYmd
                        ? moment(sp.dateToYmd).toDate()
                        : null
                );

            } else if (sp && sp.key === 'custom') {
                setStartDate(initStartDate || null);
                setEndDate(initEndDate || null);
            }

            setSelectedPeriod(selectedOption.value);

        } else {
            setSelectedPeriod('');
            setStartDate(null);
            setEndDate(null);
        }
    };

    return (
        <Ax>
            <div className="row g-2">

                <div
                    className={`${props?.cols ? props.cols : 'col-sm-4'}`}
                    style={{ zIndex: props?.zIndex ? 5 : "" }}
                >
                    <TapSelect
                        menuPlacement={
                            props.menuPlacement
                                ? props.menuPlacement
                                : "top"
                        }
                        isClearable={true}
                        placeholder="Select Period"
                        required={props.required || false}
                        isSearchable={true}
                        options={tapSelectOptions}
                        value={tapSelectOptions.find(
                            (o) => o?.value === selectedPeriod
                        )}
                        changeEvent={(selectedOption) => {
                            tapSelectChange(selectedOption);
                        }}
                        containerHeight={
                            props.containerHeight
                                ? props.containerHeight
                                : null
                        }
                        fontSize={
                            props.fontSize
                                ? props.fontSize
                                : null
                        }
                    />
                </div>
                <div
                    className={`${props?.cols ? props.cols : 'col-sm-4'}`}
                    style={{ zIndex: props?.zIndex ? 4 : "" }}
                >
                    <div className="add_calender_section pt-0">
                        <DatePicker
                            selected={startDate}
                            onChange={(date) => {
                                setStartDate(date);
                                if (selectedPeriod !== 'custom') {
                                    setSelectedPeriod('custom');
                                }
                            }}
                            dateFormat="dd-MMM-yyyy"
                            className="form-control"
                            placeholderText="Start Date"
                            required={props.required || false}
                            disabled={selectedPeriod !== 'custom'}
                            maxDate={endDate}
                        />

                        <tapIcon.imageIcon
                            icon={tapIcon.CalenderIcon}
                            className="add_calender-icon"
                        />
                    </div>
                </div>

                <div
                    className={`${props?.cols ? props.cols : 'col-sm-4'}`}
                    style={{ zIndex: props?.zIndex ? 3 : "" }}
                >
                    <div className="add_calender_section pt-0">
                        <DatePicker
                            selected={endDate}
                            onChange={(date) => {
                                setEndDate(date);
                                if (selectedPeriod !== 'custom') {
                                    setSelectedPeriod('custom');
                                }
                            }}
                            dateFormat="dd-MMM-yyyy"
                            className="form-control"
                            placeholderText="End Date"
                            required={props.required || false}
                            disabled={selectedPeriod !== 'custom'}
                            minDate={startDate}
                        />

                        <tapIcon.imageIcon
                            icon={tapIcon.CalenderIcon}
                            className="add_calender-icon"
                        />
                    </div>
                </div>

            </div>
        </Ax>
    );
};

export default PeriodSelectionWithSeparateDates;